export { default } from './StockGoods';
